import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RTPageLayout from '../common/RTPageLayout';
import Tile from '../common/Tile';
import RequireMenuAccess from '../common/RequireMenuAccess';
import '../common/rtCommon.css';
import '../common/Tile.css';
import './ComplaintManagement.css';
import ComplaintTypesList from './ComplaintTypesList';

const tiles = [
  {
    icon: '📝',
    title: 'Add a Complaint',
    permissionKey: 'complaints.add',
    description: 'Report a new complaint from paying guest or staff',
    url: 'add',
  },
  {
    icon: '👤',
    title: 'My Assigned Complaints',
    permissionKey: 'complaints.my_assigned',
    description: 'View complaints assigned to me',
    url: 'my-assigned',
  },
  {
    icon: '📂',
    title: 'View Open Complaints',
    permissionKey: 'complaints.view_open',
    description: 'See all pending and in-progress complaints',
    url: 'view',
  },
  {
    icon: '📋',
    title: 'View Complaints History',
    permissionKey: 'complaints.history',
    description: 'Browse all resolved and closed complaints',
    url: 'history',
  },
];

const ComplaintManagement = () => {
  const [activeTile, setActiveTile] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleTileClick = (tile) => {
    setActiveTile(tile);
  };

  if (activeTile === 'types') {
    return <ComplaintTypesList onBack={() => setActiveTile(null)} />;
  }

  return (
    <RequireMenuAccess>
      <RTPageLayout
        title="Complaint Management"
        mainSection
        activePath={location.pathname}
      >
        <div className="rt-tiles-grid">
          {tiles.map((tile, idx) => (
            <Tile
              key={idx}
              title={tile.title}
              icon={tile.icon}
              description={tile.description}
              permissionKey={tile.permissionKey}
              onClick={() => tile.url && navigate(tile.url)}
              tabIndex={0}
              role="button"
              onKeyPress={(e) => {
                if (e.key === 'Enter' && tile.url) navigate(tile.url);
              }}
            />
          ))}
          <Tile
            title="Complaint Types"
            description="View, add, edit, and delete complaint types."
            icon="🔧"
            permissionKey="complaints.types"
            onClick={() => handleTileClick('types')}
            tabIndex={0}
            role="button"
            onKeyPress={(e) => {
              if (e.key === 'Enter') handleTileClick('types');
            }}
          />
        </div>
      </RTPageLayout>
    </RequireMenuAccess>
  );
};

export default ComplaintManagement;
